import { API } from '../config/apiConfig';

/**
 * Fast placement-tree max depth from precomputed cache (mlm.PlacementClosure).
 * Returns null if the API is unavailable — caller may fall back to tree walk.
 */
export async function fetchPlacementMaxDepth(userId, { headers = {}, maxLevel = 15 } = {}) {
  if (!userId) return null;
  try {
    const res = await fetch(
      API.downlineLevelCounts(userId, { treeType: 'PLACEMENT', maxLevel }),
      { headers }
    );
    const data = await res.json().catch(() => ({}));
    if (res.ok && data?.success) {
      return Number(data.maxDepth) || 0;
    }
  } catch {
    /* caller fallback */
  }
  return null;
}

/**
 * Community downline stats (ActiveConnections rules) from mlm.CommunityDownline.
 */
export async function fetchCommunityDownlineStats(userId, { headers = {}, maxLevel = 32767 } = {}) {
  if (!userId) return null;
  try {
    const res = await fetch(
      API.downlineLevelCounts(userId, { treeType: 'COMMUNITY', maxLevel }),
      { headers }
    );
    const data = await res.json().catch(() => ({}));
    if (res.ok && data?.success) {
      return {
        totalCount: Number(data.totalCount) || 0,
        maxDepth: Number(data.maxDepth) || 0,
        levelCounts: Array.isArray(data.levelCounts) ? data.levelCounts : [],
        treeType: data.treeType || 'COMMUNITY',
      };
    }
  } catch {
    /* caller fallback */
  }
  return null;
}
